<template>
	<div>
		<i-modal ref="modalSuccess" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<AlertModal title="Berhasil" success message="Tautan berhasil disalin" type="alert" @remove="$refs.modalSuccess.modalHide()"/>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>
		<button class="mt-2 pl-2 btn bg-white cus-box-shadow rounded-cus box-blue" type="button" @click="copyme">
			<div class="font-size-10 d-flex">
				<i class="fas fa-share-alt mt-auto mb-auto"></i>
				<span class="pl-2">Bagikan Tautan Toko</span>
				<input type="hidden" :value="getUrlReferal()" id="inputCopy">
			</div>
		</button>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import IModal from '@/components/IModal'
import AlertModal from '@/components/elements/alert/AlertModal';
export default {
	components: {
		IModal,
		AlertModal
	},
	computed: {
		...mapState('auth', ['userData']),
	},
	methods: {
		getUrlReferal() {
			return `${process.env.VUE_APP_STORE_URL}/mobile-counter/${this.userData.stockist_code}`
		},
		copyme() {
			var copyText = document.getElementById("inputCopy")
			copyText.setAttribute('type', 'text')
			copyText.select()
			try {
				document.execCommand('copy');
				setTimeout(() => {
					this.$refs.modalSuccess.modalShow()
				}, 300);
			} catch (err) {
				alert('Oops, tidak dapat menyalin');
			}
			copyText.setAttribute('type', 'hidden')
			window.getSelection().removeAllRanges()
		},
	}
}
</script>